/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useCallback, useEffect, useContext } from 'react'
import Debounce from '../../../../../CommonMethods/Debounce'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick'
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId'
import { dataService } from '../../../../../services/data.services'
import moment from 'moment'
import GlobalContext from '../../../../../components/Context/GloablContext'
import { ShimmerTitle } from 'react-shimmer-effects'

export default function InvoiceReferenceDropdown({
    handleSearchFiled,
    index,
    invoiceReference,
    account_id,
    buttonDisabled
}) {
    const inputRef=useRef()
    const [dropdownData, setDropdownData] = useState([])
    const [searchValue, setSearchValue] = useState("")
    const [isDropdownOpen, setIsDropDownOpen] = useState(false)
    const {setToastErrorMessage} = useContext(GlobalContext)
    /* The `useOnClickOutside` custom hook is used to detect clicks that occur outside a specified
    element, in this case, the element referenced by `inputRef`. When a click event is detected
    outside this element, the callback function `() => { setDropdownData([]); }` is executed. In
    this specific context, it is used to close the dropdown menu by clearing the dropdown data when
    a click occurs outside the dropdown element. */
    useOnClickOutside(inputRef, () => {
        setIsDropDownOpen(false);
    });

    /* The `const handelSearchInput` is using the `useCallback` hook to memoize a callback function. It
    is creating a debounced version of the `handelSearchInputDebounce` function using the `Debounce`
    utility function. This debounced function will be called with the provided arguments `(value,
    selectedMultiField, selectedAccountFelid)` and will handle the search input with a delay to
    improve performance and prevent excessive API calls. */
    const handelSearchInput = useCallback(
        Debounce((value) => handelSearchInputDebounce(value)),
        [account_id]
    );

    /**
     * The function `handelSearchInputDebounce` handles debounced search input for fetching data based
     * on certain conditions and updating the dropdown accordingly.
     * @returns The function `handelSearchInputDebounce` returns a cleanup function that clears the
     * timeout set by `setTimeout` when the function is called.
     */
    const handelSearchInputDebounce =async (value) => {
        const branch_id = await GetBranchId();
        const timer=setTimeout(async ()=>{
            let searchValue = encodeURIComponent(value).replace(/[#&]/g, '\\$&').trim()
            if(searchValue !== "") {   
                // let copy = copyParams.delete("fy_status")
                try{
                    const res = await dataService.GetAPI(`payables?branch_id=${branch_id}&account_id=${account_id}&search=${searchValue}&role=vouchers-entry`, true);
                    setDropdownData(res?.data?.data?.data)
                }catch(error){
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    console.log("error", error)
                }
            } else {
                const res = await dataService.GetAPI(`payables?branch_id=${branch_id}&account_id=${account_id}&role=vouchers-entry`, true);
                setDropdownData(res?.data?.data?.data)
            }
        },500)
        return()=>{
            clearTimeout(timer)
        }
    }

    /**
     * The `handleOnClickButton` function makes an asynchronous call to retrieve data from an API based
     * on certain conditions and logs the response or any errors encountered.
     */
    const handleOnClickButton = async (e) => {
        if(!isDropdownOpen) {
            setIsDropDownOpen(true)
        } else {
            setIsDropDownOpen(false);
        }
    }


    /**
     * The function `getInvoiceReferenceNumbers` retrieves invoice reference numbers based on branch and
     * account IDs using asynchronous calls.
     */
    const [invRefNoLoading, setInvRefNoLoading] = useState(false)
    const getInvoiceReferenceNumbers = async() => {
        try {
            setInvRefNoLoading(true)
            const branch_id = await GetBranchId()
            const res = await dataService.GetAPI(`payables?branch_id=${branch_id}&account_id=${account_id}&role=vouchers-entry`, true);
            setDropdownData(res?.data?.data?.data)
            // setIsDropDownOpen(true);
        } catch (error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.log("error", error)
            setInvRefNoLoading(false)
        } finally{
            setInvRefNoLoading(false)
        }
    }

    useEffect(() => {
        if(account_id !== ''){
            getInvoiceReferenceNumbers()
        }
    }, [account_id])

    return (
        <div class={`relative w-[200px] pl-5`} ref={inputRef}>
            <button
                disabled={buttonDisabled}
                className={`border border-[#D0D5DD] more-lines rounded block w-full pr-[35px] pl-1.5 py-1.5 text-start placeholder:text-f7 placeholder:text-[#818E98] placeholder:font-normal text-f7 font-normal text-[#031624] outline-none`} 
                type="button" 
                id="invoice_reference_button"
                onClick={() => handleOnClickButton()}
                // onClick={()=> {getListOfGroup(); setIsSelectDropdown(!isSelectDropdown)}}
                title={invoiceReference.invoice_reference_number === undefined ? "" : `${invoiceReference.invoice_reference_number} (${moment(invoiceReference.invoice_date).format("MMM DD, YYYY")})`}
            >
                <p class={`text-f7 more-lines ${ invoiceReference.invoice_reference_number === undefined ? "text-[#818E98]" : "text-[#344054] "} font-normal`}>
                    {invoiceReference.invoice_reference_number === undefined ?  "Select Reference #" : `${invoiceReference.invoice_reference_number} (${moment(invoiceReference.invoice_date).format("MMM DD, YYYY")})`}
                </p>
                <img loading="lazy" src="/images/dropdown-icon.png" alt="icon" class={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${isDropdownOpen ? "transform rotate-180" : ""}`}/>
            </button>
            {isDropdownOpen &&
            <>
                
                <ul class="slct_drp_dwn min-w-full w-[310px] [&[data-te-dropdown-show]]:block select_student" aria-labelledby="dropdownMenu_acdemic_year" data-te-dropdown-menu-ref>
                    <li className='relative mb-1 p-1'>
                        <input 
                            type="text" 
                            // className={`border  ${(submitSelected && multiField[index].item_name === "" || selectedErrorState === index) ? "border-[#F04438]" : "border-[#D0D5DD]"} bg-white rounded w-full px-3.5 py-1.5 text-f7 font-normal text-[#101828] placeholder:text-f7 placeholder:text-normal placeholder:text-[#818E98] outline-0 error_border`} 
                            className={`slct-inpt-fld`} 
                            style={{'padding-right':'35px'}}
                            placeholder="Search Reference #" 
                            id="invoice_reference_search_input"
                            autocomplete="off" 
                            onChange={e=>{
                                setSearchValue(e.target.value)
                                handelSearchInput(e.target.value)
                                // setSelectedErrorState(null)
                            }}
                            value={searchValue} 
                        />
                        <button class="absolute top-[50%] -translate-y-[50%] right-2">
                            <img loading="lazy" decoding="async" src="/images/search.svg" alt="img" />
                        </button>
                    </li>
                    {invRefNoLoading ?
                        <li className='max-h-[150px] overflow-auto scroll-bar'>
                            <p className="text-2xl font-bold text-[#031624] mb-4 mt-4"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                            <p className="text-2xl font-bold text-[#031624] mb-4"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                            <p className="text-2xl font-bold text-[#031624] mb-1"><ShimmerTitle line={1} gap={6} variant="secondary" className="w-[270px]"/></p>
                        </li> : 
                        Object.values(dropdownData).length !== 0 ? 
                            <li className="max-h-[150px] overflow-auto scroll-bar" >
                                {Object.values(dropdownData)?.map((search_item)=>(
                                    <ul key={search_item}>
                                        {
                                            <li>
                                                <a
                                                    className="cursor-pointer block w-full more-lines bg-white pr-2 mb-3 text-f7 font-normal text-[#031624] selected_Class" 
                                                    onClick={() => {
                                                        setIsDropDownOpen(false);
                                                        handleSearchFiled(index, search_item, "invoice_reference_number"); 
                                                    }} 
                                                    id={search_item.reference_number}
                                                    title={`${search_item.reference_number} (${moment(search_item.date).format("MMM DD, YYYY")})`}
                                                >{search_item.reference_number} ({moment(search_item.date).format("MMM DD, YYYY")})
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                ))
                                } 
                            </li> :
                            <li className="max-h-[150px] overflow-auto scroll-bar ml-2" >
                                <ul>
                                    <li>
                                        <a
                                            className="cursor-pointer block w-full more-lines bg-white pr-2 mb-3 text-f7 font-normal text-[#031624] selected_Class" 
                                        >No data found.
                                        </a>
                                    </li>
                                </ul>
                            </li>
                    }
                </ul> 
            </>}
        </div>  
    )
}
